export const iconFontAwesomeMoneyCentSign = (
	<i className="fa-solid fa-cent-sign"></i>
);
